"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));

var _withStyles = _interopRequireDefault(require("@material-ui/styles/withStyles"));

var StylesLinearProgress = (0, _withStyles["default"])({
  root: {
    height: 20
  }
})(_LinearProgress["default"]);

var _default = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var value = _ref.value;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative",
    style: {
      zIndex: 0
    }
  }, /*#__PURE__*/_react["default"].createElement(StylesLinearProgress, {
    variant: value >= 100 ? 'indeterminate' : 'determinate',
    value: Math.min(100, value)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute text-white inset-0 flex items-center justify-center text-xs"
  }, +Math.min(value, 99.9).toFixed(1), "%"));
});

exports["default"] = _default;
//# sourceMappingURL=Progress.js.map